const imageContext = require.context("../images", true, /\.(png|jpe?g|svg|gif)$/);

const resolveFromContext = (relativePath) => {
  try {
    return imageContext(relativePath);
  } catch (error) {
    return null;
  }
};

export const resolveLogoSrc = (logo) => {
  if (!logo) {
    return null;
  }

  const trimmed = String(logo).trim();
  if (!trimmed) {
    return null;
  }

  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("//") ||
    trimmed.startsWith("/") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }

  if (trimmed.includes("images/")) {
    const normalized = trimmed
      .replace(/^(\.\.\/)+/, "")
      .replace(/^\.\//, "");
    return `${process.env.PUBLIC_URL}/${normalized}`;
  }

  const normalized = trimmed
    .replace(/^(\.\.\/)+/, "")
    .replace(/^\.\//, "");

  return (
    resolveFromContext(`./${normalized}`) ||
    resolveFromContext(`./companies/${normalized}`) ||
    null
  );
};
